import(/* webpackMode: "eager", webpackExports: ["GroupDirectory"] */ "/workspace/.ci/web-hosting-src/platform/groups/GroupDirectory.tsx");
